module.exports = __webpack_public_path__ + "static/04-d11ae4bc2568dcbd16dca089fbc7418a.jpg";